import React from 'react';
import { NodeProps } from 'components/canvas/components/nodes/components/base-node';
import TextNode from 'components/canvas/components/nodes/components/text-node';
import { set } from 'lodash/fp';

interface TextSnippetNodeProps extends NodeProps {}

function TextSnippetNode(props: TextSnippetNodeProps) {
  const node = set('isReference', true, props.node);

  return <TextNode {...props} node={node} />;
}

export default TextSnippetNode;
